<template>
  <f7-page name='error'>
    <bc-navbar></bc-navbar>
    <div id="pages_maincontent">
      <div class="error-wrapper">
        <h1> Ooops:(</h1>
        <blockquote>
          Something went wrong
        </blockquote>
      </div>
    </div>
  </f7-page>
</template>
<script>
  export default {
    data () {
      return {}
    }
  }
</script>
<style scoped>
  #pages_maincontent {
    text-align: center;
  }

  .error-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// error.vue?2dd6d089